<script>
import _ from 'lodash';
import fieldComponents from './fields/fieldsLoader.js';
import { h, resolveComponent } from 'vue';

export default {
  name: 'cFormGroup',
  components: fieldComponents,
  props: {
    model: {
      type: Object,
      default: () => {}
    },
    field: {
      type: Object,
      required: true
    },
    cols: {
      type: Number,
      default: 1
    },
    labelWeight: {
      type: Number,
      default: 700
    },
    labelWidth: {
      type: Number,
      default: undefined
    },
    labelSize: {
      validator: function (value) {
        // The value must match one of these strings
        return ['small', 'medium', 'large'].indexOf(value) !== -1;
      },
      default: 'medium'
    },
    errors: {
      type: Array,
      default() {
        return [];
      }
    },
    view: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    colsStyle() {
      return {
        width:
          this.field.widthBlock || this.cols === 1 ? '100%' : `calc(${100 / this.cols}% - 35px)`
      };
    },
    labelSz() {
      let val;
      if (this.labelSize === 'small') {
        val = 90;
      } else if (this.labelSize === 'medium') {
        val = 120;
      } else if (this.labelSize === 'large') {
        val = 170;
      }
      return val;
    }
  },
  methods: {
    fieldTypeHasLabel(field) {
      if (_.isNil(field.label)) return false;
      return true;
    },
    getFieldType(fieldSchema) {
      return 'field-' + fieldSchema.type;
    },
    fieldHint(field) {
      if (_.isFunction(field.hint)) return field.hint.call(this, this.model, field, this);
      return field.hint;
    },
    onModelUpdated(newVal, schema) {
      this.$emit('model-updated', newVal, schema);
    }
  },
  render() {
    const { field, model, $theme, labelWeight, labelWidth, view, labelSz } = this;
    const legoIcon = resolveComponent('lego-icon');
    const legoTooltip = resolveComponent('lego-tooltip');
    const cLabel = resolveComponent('c-label');
    const fieldHelp =
      field.help &&
      h('span', { class: 'help' }, [
        h(legoIcon, {
          id: 'manual',
          iconType: 'df',
          icon: 'info',
          size: 16
        }),
        h(legoTooltip, { top: true, mouseOver: true }, [field.help])
      ]);

    const fieldContainer =
      this.fieldTypeHasLabel(field) &&
      h(
        'div',
        {
          for: field.id,
          class: 'c-form-group-label',
          style: {
            width: labelWidth ? `${labelWidth}` : `${labelSz}`,
            flex: labelWidth ? `0 0 ${labelWidth}px` : `0 0 ${labelSz}px`
          }
        },
        [
          h(
            cLabel,
            {
              inline: true,
              color: $theme.COLOR.UI.UI02,
              weight: labelWeight,
              style: {
                whiteSpace: 'pre-wrap'
              }
            },
            [field.label]
          ),
          field.required &&
            h('span', [
              h(
                cLabel,
                {
                  style: {
                    marginLeft: '4px'
                  },
                  weight: 700,
                  inline: true,
                  color: $theme.COLOR.STATUS.ERROR
                },
                ['*']
              )
            ]),
          field.labelInfoHtml && h('span', { innerHTML: field.labelInfoHtml() }, []),
          fieldHelp
        ]
      );

    const fieldContainerGroup =
      field.group &&
      field.group.map((item, idx) => {
        return h(
          this.getFieldType(item),
          {
            key: idx,
            model: model,
            schema: item,
            'onModel-updated': this.onModelUpdated,
            style: {
              display: item.hide && 'none'
            }
          },
          [this.$slots.default && this.$slots.default()]
        );
      });

    const fieldContainerSingle =
      !field.group &&
      h(
        this.getFieldType(field),
        {
          model,
          schema: field,
          ref: field.fieldId && field.fieldId,
          'onModel-updated': this.onModelUpdated
        },
        [this.$slots.default && this.$slots.default()]
      );

    const hintText =
      this.field.hint &&
      h('div', {
        innerHTML: this.fieldHint(field),
        class: 'hint'
      });

    return h(
      'div',
      {
        class: {
          'c-form-group': true,
          'c-form-group-view': view
        },
        style: { ...this.colsStyle, ...field.formStyle }
      },
      [
        fieldContainer,
        h(
          'div',
          {
            class: [{ 'field-wrap': true }, `field-${field.textarea ? 'textarea' : field.type}`]
          },
          [
            fieldContainerGroup,
            fieldContainerSingle,
            field.unit && h('span', { class: 'unit' }, [field.unit]),
            hintText
          ]
        )
      ]
    );
  }
};
</script>
<style lang="scss" scoped>
.c-form-group {
  display: flex;
  padding-top: 2px;
  margin-bottom: 20px;
  min-width: 0;

  &:nth-last-child(1) {
    margin-bottom: 0;
  }

  &-view {
    .c-form-group-label {
      padding-top: 0;
    }

    .field-wrap {
    }
  }

  &-label {
    width: 120px;
    flex: 0 0 120px;
    min-height: 26px;
    padding-top: 6px;

    .help {
      position: relative;
      top: 2px;
      left: 4px;
    }
  }

  .field-wrap {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    align-items: stretch;

    span + button {
      margin-left: 8px;
    }

    > div + div {
      margin-left: 8px;
    }

    > div + span,
    > span + div {
      margin-left: 8px;
    }

    .unit {
      line-height: 32px;
    }

    .hint {
      width: 100%;
      color: $color--ui04;
      margin-top: 8px;
      margin-left: 0px;
    }

    .wrapper {
      width: 100%;
      display: flex;
      align-self: center;
    }
  }
}
</style>
